module.exports = "/assets/img/ipallets/imeasure_logo.png";